[{
	"value": "weight",
	"label": "Weight",
	"dateFormat": "MM/DD/YYYY",
	"unit": "pounds",
	"fields": [{
		"label": "Weight in Pounds",
		"type": "number",
		"format": "0.0",
		"suffix": "lbs"
	}]
}, {
	"value": "height",
	"label": "Height",
	"dateFormat": "MM/DD/YYYY",
	"unit": "feet|inches",
	"fields": [{
		"label": "Feet",
		"type": "number",
		"suffix": "ft"
	}, {
		"label": "Inches",
		"type": "number",
		"suffix": "in"
	}]
}, {
	"value": "heart-rate",
	"label": "Heart Rate",
	"dateFormat": "MM/DD/YYYY h:mm a",
	"unit": "bpm",
	"fields": [{
		"label": "Beats per minute",
		"type": "number",
		"suffix": "BPM"
	}]
}, {
	"value": "blood-pressure",
	"label": "Blood Pressure",
	"dateFormat": "MM/DD/YYYY",
	"unit": "systolic|diastolic",
	"fields": [{
		"label": "Systolic",
		"type": "number",
		"suffix": "over"
	}, {
		"label": "Diastolic",
		"type": "number"
	}]
}, {
	"value": "a1c",
	"label": "A1C",
	"dateFormat": "MM/DD/YYYY",
	"unit": "mgperdl",
	"fields": [{
		"label": "Value",
		"type": "number",
		"addOn": "mg/dL",
		"suffix": "mg/dL"
	}]
}, {
	"value": "glucose",
	"label": "Glucose",
	"dateFormat": "MM/DD/YYYY",
	"unit": "mgperdl",
	"fields": [{
		"label": "Value",
		"type": "number",
		"addOn": "mg/dL",
		"suffix": "mg/dL"
	}]
}, {
	"value": "ldl",
	"label": "LDL Cholesterol",
	"dateFormat": "MM/DD/YYYY",
	"unit": "mgperdl",
	"fields": [{
		"label": "Value",
		"type": "number",
		"addOn": "mg/dL",
		"suffix": "mg/dL"
	}]
}, {
	"value": "hdl",
	"label": "HDL Cholesterol",
	"dateFormat": "MM/DD/YYYY",
	"unit": "mgperdl",
	"fields": [{
		"label": "Value",
		"type": "number",
		"addOn": "mg/dL",
		"suffix": "mg/dL"
	}]
}, {
	"value": "triglycerides",
	"label": "Triglycerides",
	"dateFormat": "MM/DD/YYYY",
	"unit": "mgperdl",
	"fields": [{
		"label": "Value",
		"type": "number",
		"addOn": "mg/dL",
		"suffix": "mg/dL"
	}]
}]
